/**
 * The inbox entry of the top menu: a router link with the unread count as a badge.
 */
import { Link } from 'react-router-dom';
import { Badge, Icon } from '@insio/ui-toolkit';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { navigation } from '@/navigation';

/** Counts above this show as "99+" so the badge keeps its width. */
const BADGE_MAX = 99;

interface InboxMenuLinkProps {
  unreadCount: number;
  isActive: boolean;
  className: string;
}

export function InboxMenuLink({ unreadCount, isActive, className }: InboxMenuLinkProps) {
  const t = useFeatureTranslation('inbox');
  const tone = isActive ? 'text-secondary-base' : 'text-foreground-base';

  return (
    <Link to={navigation.notifications()} className={className} data-testid='inbox-menu-link'>
      <Icon name='bell' className={tone} />
      <span className={`font-medium ${tone}`}>{t('title')}</span>
      {unreadCount > 0 && (
        <>
          <span aria-hidden='true' data-testid='inbox-menu-badge'>
            <Badge size='sm' color='error'>
              {unreadCount > BADGE_MAX ? t('menu.badgeOverflow') : unreadCount}
            </Badge>
          </span>
          <span className='sr-only'>{t('menu.unread', { count: unreadCount })}</span>
        </>
      )}
    </Link>
  );
}
